module.exports = __webpack_public_path__ + "static/media/worker-cat-still.db5db26d.png";